import { jsxs as n, jsx as t } from "react/jsx-runtime";
const e = ({
  width: o,
  height: L,
  className: l
}) => /* @__PURE__ */ n(
  "svg",
  {
    className: l,
    fill: "none",
    height: L,
    viewBox: "0 0 13 11",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M5.44419 0.578947C5.91344 -0.192983 7.08656 -0.192982 7.55581 0.578947L12.8348 9.26316C13.3041 10.0351 12.7175 11 11.779 11H1.22096C0.282465 11 -0.304095 10.0351 0.165153 9.26316L5.44419 0.578947Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M7.21802 3.34508L5.89051 3.34508L5.89051 7.12753L7.21802 7.12753L7.21802 3.34508ZM7.21802 8.38835L5.89051 8.38835L5.89051 9.64917L7.21802 9.64917L7.21802 8.38835Z",
          fill: "white"
        }
      )
    ]
  }
);
export {
  e as Content
};
